import { render, staticRenderFns } from "./GroupDirectoriesDashboard.vue?vue&type=template&id=5baa21e1&"
import script from "./GroupDirectoriesDashboard.vue?vue&type=script&lang=js&"
export * from "./GroupDirectoriesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports